
import { useState, useEffect } from 'react';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsApp = () => {
    window.open('https://wa.me/5531993801237?text=Olá%2C%20gostaria%20de%20falar%20com%20Dr.%20José.', '_blank');
  };

  const handlePhone = () => {
    window.location.href = 'tel:+5531993801237';
  };

  return (
    <div className="min-h-screen bg-[#1E3A5F]">
      {/* Header Fixo */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-[#1a2451] shadow-lg shadow-black/20' : 'bg-[#1a2451]'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4 flex items-center justify-between">
          <div className="flex items-center gap-2 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/2eebc5b863ce59f6c5c9dea57a1500ad/c4cdf68fb9835c7c207fec07d572e82f.png" 
                alt="Logo José Lopes Veloso Junior" 
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h1 className="text-sm md:text-xl font-semibold text-white font-serif">
                José Lopes Veloso Junior
              </h1>
              <p className="text-xs md:text-sm text-white/70">
                OAB/MG 101596 | Direito Bancário
              </p>
            </div>
          </div>
          <div className="hidden md:flex items-center gap-4">
            <button
              onClick={handleWhatsApp}
              className="flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-full font-medium hover:bg-[#20BD5A] transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              WhatsApp
            </button>
            <button
              onClick={handlePhone}
              className="flex items-center gap-2 border-2 border-white text-white px-6 py-3 rounded-full font-medium hover:bg-white hover:text-[#1E3A5F] transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              Telefone
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section - Otimizado para intenção de busca */}
      <section className="pt-24 md:pt-32 pb-10 md:pb-16 bg-gradient-to-b from-[#1E3A5F] to-[#162D4A]">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <div className="mb-5 md:mb-6 flex justify-center">
            <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-white/20 shadow-xl">
              <img 
                src="https://static.readdy.ai/image/2eebc5b863ce59f6c5c9dea57a1500ad/c4cdf68fb9835c7c207fec07d572e82f.png" 
                alt="José Lopes Veloso Junior - Advogado" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-3 md:mb-4 font-serif">
            Advogado em Direito Bancário
          </h2>
          <p className="text-base md:text-lg text-white/90 mb-2 md:mb-3 font-medium">
            Análise técnica de contratos, juros e cobranças bancárias
          </p>
          <p className="text-sm md:text-base text-white/70 mb-5 md:mb-6">
            Atendimento remoto para pessoas físicas e jurídicas em Minas Gerais
          </p>
          <div className="inline-flex items-center gap-2 bg-white/10 text-white px-4 md:px-5 py-2 rounded-full mb-6 md:mb-8">
            <i className="ri-map-pin-line text-sm"></i>
            <span className="text-xs md:text-sm font-medium">
              OAB/MG 101596 | Região Metropolitana de BH
            </span>
          </div>
          
          {/* CTA Principal no Hero */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <button
              onClick={handleWhatsApp}
              className="w-full sm:w-auto flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-medium hover:bg-[#20BD5A] transition-all whitespace-nowrap cursor-pointer text-sm md:text-base shadow-lg"
            >
              <i className="ri-whatsapp-line text-lg md:text-xl"></i>
              Solicitar Análise Jurídica
            </button>
            <button
              onClick={handlePhone}
              className="w-full sm:w-auto flex items-center justify-center gap-2 border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-medium hover:bg-white hover:text-[#1E3A5F] transition-all whitespace-nowrap cursor-pointer text-sm md:text-base"
            >
              <i className="ri-phone-line text-lg md:text-xl"></i>
              Ligar Agora
            </button>
          </div>
        </div>
      </section>

      {/* Seção de Áreas de Atuação - Priorizada */}
      <section id="areas-atuacao" className="py-10 md:py-16 bg-[#1E3A5F]">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-6 md:mb-10">
            <h3 className="text-xl md:text-3xl font-bold text-white mb-3 font-serif">
              Áreas de Atuação em Direito Bancário
            </h3>
            <div className="w-16 h-1 bg-white mx-auto"></div>
          </div>
          <div className="grid md:grid-cols-2 gap-4 md:gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6 hover:bg-white/15 transition-all duration-300 border border-white/10">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-text-line text-lg md:text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-base md:text-lg font-bold text-white mb-2">
                    Contratos Bancários
                  </h4>
                  <p className="text-white/70 text-sm leading-relaxed">
                    Análise de cláusulas contratuais em financiamentos, empréstimos e operações de crédito.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6 hover:bg-white/15 transition-all duration-300 border border-white/10">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                  <i className="ri-percent-line text-lg md:text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-base md:text-lg font-bold text-white mb-2">
                    Juros e Encargos
                  </h4>
                  <p className="text-white/70 text-sm leading-relaxed">
                    Verificação de taxas de juros, encargos e índices de correção monetária aplicados.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6 hover:bg-white/15 transition-all duration-300 border border-white/10">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                  <i className="ri-alert-line text-lg md:text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-base md:text-lg font-bold text-white mb-2">
                    Cobranças Indevidas
                  </h4>
                  <p className="text-white/70 text-sm leading-relaxed">
                    Análise de lançamentos bancários, tarifas e débitos sem fundamentação contratual.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6 hover:bg-white/15 transition-all duration-300 border border-white/10">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                  <i className="ri-hand-coin-line text-lg md:text-xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-base md:text-lg font-bold text-white mb-2">
                    Renegociação Bancária
                  </h4>
                  <p className="text-white/70 text-sm leading-relaxed">
                    Orientação técnica sobre propostas de renegociação e alternativas contratuais.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção CTA - Chamada para Contato */}
      <section id="contato" className="py-10 md:py-14 bg-white">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h3 className="text-xl md:text-3xl font-bold text-[#1E3A5F] mb-2 md:mb-3 font-serif">
            Encaminhe Suas Informações
          </h3>
          <p className="text-sm md:text-base text-[#1E3A5F]/70 mb-5 md:mb-6">
            Solicite uma análise jurídica inicial da sua demanda bancária
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-4">
            <button
              onClick={handleWhatsApp}
              className="w-full sm:w-auto flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-medium hover:bg-[#20BD5A] transition-all whitespace-nowrap cursor-pointer text-sm md:text-base shadow-md"
            >
              <i className="ri-whatsapp-line text-lg md:text-xl"></i>
              Enviar Mensagem
            </button>
            <button
              onClick={handlePhone}
              className="w-full sm:w-auto flex items-center justify-center gap-2 bg-[#1E3A5F] text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-medium hover:bg-[#162D4A] transition-all whitespace-nowrap cursor-pointer text-sm md:text-base"
            >
              <i className="ri-phone-line text-lg md:text-xl"></i>
              (31) 99380-1237
            </button>
          </div>
          <p className="text-xs text-[#1E3A5F]/50">
            Atendimento com horários flexíveis | Resposta em até 24h úteis
          </p>
        </div>
      </section>

      {/* Seção Institucional - Conteúdo Explicativo (Reduzido) */}
      <section className="py-10 md:py-14 bg-[#162D4A]">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-center mb-6 md:mb-8">
            <h3 className="text-xl md:text-3xl font-bold text-white mb-3 font-serif">
              Sobre o Direito Bancário
            </h3>
            <div className="w-16 h-1 bg-white mx-auto"></div>
          </div>
          <div className="space-y-4 text-white/80 leading-relaxed text-sm md:text-base">
            <p>
              O Direito Bancário regula as relações entre instituições financeiras e seus clientes, abrangendo operações de crédito, contratos bancários e transações no sistema financeiro nacional.
            </p>
            <p>
              A atuação profissional envolve análise técnica de contratos, verificação de conformidade legal de cláusulas e exame de encargos financeiros sob a perspectiva da legislação vigente.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F1E2E] text-white/70 py-8 md:py-10">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-6">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden">
                  <img 
                    src="https://static.readdy.ai/image/2eebc5b863ce59f6c5c9dea57a1500ad/c4cdf68fb9835c7c207fec07d572e82f.png" 
                    alt="Logo" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h4 className="text-white font-semibold text-sm md:text-base">José Lopes Veloso Junior</h4>
                  <p className="text-xs md:text-sm">OAB/MG 101596</p>
                </div>
              </div>
            </div>

            <div>
              <h5 className="text-white font-bold mb-3 text-sm md:text-base">Contato</h5>
              <div className="space-y-2 text-xs md:text-sm">
                <div className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  <span>(31) 99380-1237</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>Jlvelosojunior@gmail.com</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-map-pin-line"></i>
                  <span>Atendimento Remoto - MG</span>
                </div>
              </div>
            </div>

            <div>
              <h5 className="text-white font-bold mb-3 text-sm md:text-base">Avisos Legais</h5>
              <div className="space-y-2 text-xs md:text-sm leading-relaxed">
                <p>Conteúdo de caráter exclusivamente informativo.</p>
                <p>A contratação depende de análise individual do caso.</p>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-4">
            <p className="text-center text-xs text-white/40">
              © 2025 José Lopes Veloso Junior - OAB/MG 101596 | Todos os direitos reservados | <a href="https://readdy.ai/?ref=logo" rel="nofollow" className="hover:text-white transition-colors">JLadvocacia</a>
            </p>
          </div>
        </div>
      </footer>

      {/* Botão Flutuante WhatsApp */}
      <a
        href="https://wa.me/5531993801237?text=Olá%2C%20gostaria%20de%20falar%20com%20Dr.%20José."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-black/30 hover:bg-[#20BD5A] hover:scale-110 transition-all duration-300 cursor-pointer"
        aria-label="Contato via WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-2xl"></i>
      </a>
    </div>
  );
}
